import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaInfoCircle, FaCopy, FaExternalLinkAlt } from "react-icons/fa";
import axios from "axios";
import moment from "moment";
import RazorPayment from "./RazorPayPayment";
import DesktopBanner from "../assets/desktop_banner.png";
import MobileBanner from "../assets/mobile_banner.png";
import CenterRegistrationApi from "../components/centerRegistration/Api/api";
import CenterComponentApi from "../components/centerComponent/api/api";
import { IndianStates } from "../assets/IndianStates";
import { BASE_URL } from "../components/config/config";

// Material UI Components
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  Typography,
  Card,
  CardMedia,
  Divider,
  IconButton,
  InputAdornment,
  TextareaAutosize,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SendIcon from "@mui/icons-material/Send";
import VerifiedIcon from "@mui/icons-material/Verified";

const AVAILABLE_TIME_PREFERENCES = [
  "IMMEDIATELY",
  "WITHIN_24_HOURS",
  "SPECIFIC_DATE_AND_TIME",
];

const PICK_DROP_AVAILABLE_TIME_PREFERENCES = [
  "IMMEDIATELY",
  "SPECIFIC_DATE_AND_TIME",
];

const PublicTicketBooking = (props) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    serviceRequired: "",
    specificRequirement: "",
    name: "",
    phoneNumber: "",
    alternatePhoneNumber: "",
    houseNumber: "",
    locality: "",
    picklocation: "",
    droplocation: "",
    offerprice: "",
    city: "",
    state: "",
    country: "INDIA",
    pincode: "",
    timePreference: "",
    offerCode: "ONIT2026",
    specific_date_time: moment(),
    toast: {
      open: false,
      msg: "",
      duration: 10000,
      type: "",
    },
    isFormValid: false,
    servicesList: [],
    isRegistering: false,
    center_obj_id: "",
    isCenterExist: false,
    centerDetails: {},
    centerName: "",
    TicketModalOpen: false,
    ticketModalData: {},
    tickectId: "",
    verifyOtp: false,
    otp: "",
    paymentStatus: "",
    needToPay: false,
    razorpayinitiate: false,
    vehicles: [],
    selectedVehicle: "",
    plateformCharge: null,
    consumerId: null,
    isMobile: false,
    otpSent: false,
    isFetchingPincode: false,
    bannerImage: null,
    isFetchingBanner: false,
  });

  const resetForm = () => {
    setState((prev) => ({
      ...prev,
      serviceRequired: "",
      specificRequirement: "",
      name: "",
      phoneNumber: "",
      alternatePhoneNumber: "",
      houseNumber: "",
      locality: "",
      picklocation: "",
      droplocation: "",
      offerprice: "",
      city: "",
      state: "",
      pincode: "",
      timePreference: "",
      specific_date_time: moment(),
      isRegistering: false,
      verifyOtp: false,
      otp: "",
      otpSent: false,
      selectedVehicle: "",
      isFormValid: false,
    }));
  };

  const updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768;
    setState((prev) => ({ ...prev, isMobile }));
  };

  useEffect(() => {
    getAllServicesExists();
    getAllVehicles();
    updateIsMobile();
    window.addEventListener("resize", updateIsMobile);

    let qrId = window.location.hash.split("/")[2];
    getCenterByQrid(qrId);

    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  const fetchBannerImage = async (qrId, centerId) => {
    setState((prev) => ({ ...prev, isFetchingBanner: true }));

    try {
      const response = await axios.get(`${BASE_URL}admin/get-common-banner`, {
        params: {
          isActive: true,
          qr_id: qrId,
        },
      });

      if (response.data.success === 1 && response.data.data.length > 0) {
        const banner = response.data.data[0];
        setState((prev) => ({
          ...prev,
          bannerImage: banner.image,
          isFetchingBanner: false,
        }));
      } else {
        // No active banner found, use default
        setState((prev) => ({
          ...prev,
          bannerImage: null,
          isFetchingBanner: false,
        }));
      }
    } catch (error) {
      console.error("Error fetching banner:", error);
      setState((prev) => ({
        ...prev,
        bannerImage: null,
        isFetchingBanner: false,
      }));
    }
  };

  const getCenterByQrid = (qrId) => {
    let payload = {
      qr_id: qrId,
    };

    new CenterRegistrationApi()
      .getCenterByQrId(payload)
      .then((res) => {
        if (
          res.data.doesCenterExists?.services?.primary_services?.[0] ===
          "64462802f77b1ff1d68890fd" &&
          res.data.doesCenterExists?.vehicleId === "65e2e3078151df1858864cab"
        ) {
          navigate(
            `/bookingPickDrop/${res.data.doesCenterExists?.qr_details?.qr_id}`
          );
        }

        const centerData = res.data.doesCenterExists;
        setState((prev) => ({
          ...prev,
          isCenterExist: res.data.isCenterExist,
          centerDetails: centerData,
          centerName: centerData?.center_name,
          center_obj_id: centerData?._id,
        }));

        // Fetch banner after getting center details
        if (qrId && centerData?._id) {
          fetchBannerImage(qrId, centerData._id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllVehicles = () => {
    new CenterComponentApi()
      .getAllVehicles()
      .then((res) => {
        setState((prev) => ({
          ...prev,
          vehicles: res.data,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllServicesExists = () => {
    new CenterRegistrationApi()
      .getAllActiveServices()
      .then((res) => {
        setState((prev) => ({
          ...prev,
          servicesList: res.data,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const showDialog = (open, type, msg) => {
    setState((prev) => ({
      ...prev,
      toast: {
        open: open,
        msg: msg,
        duration: 3000,
        type: type,
      },
    }));
  };

  const closeDialog = (open = false) => {
    setState((prev) => ({
      ...prev,
      toast: {
        open: open,
        msg: "",
        duration: 5000,
        type: "",
      },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "pincode") {
      if (value.length <= 6) {
        setState((prev) => ({
          ...prev,
          pincode: value,
        }));
      }
      return;
    }

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onChangeSpecificDateAndTime = (newValue) => {
    const cleanedValue = newValue ? moment(newValue) : null;
    setState((prev) => ({
      ...prev,
      specific_date_time: cleanedValue,
    }));
  };

  const validateFields = () => {
    const {
      serviceRequired,
      name,
      phoneNumber,
      houseNumber,
      locality,
      city,
      picklocation,
      droplocation,
      offerprice,
      pincode,
      state: stateValue,
      timePreference,
      selectedVehicle,
    } = state;

    let isValid = true;
    let errorMessage = "Please fill in all required details";

    // Check common required fields
    if (!phoneNumber || !pincode || !timePreference) {
      isValid = false;
    }

    // Check service-specific fields
    if (serviceRequired === "64462802f77b1ff1d68890fd") {
      if (!picklocation || !droplocation || !selectedVehicle || !offerprice) {
        isValid = false;
      }
    } else {
      if (
        !serviceRequired ||
        !name ||
        !houseNumber ||
        !locality ||
        !city ||
        !stateValue
      ) {
        isValid = false;
      }
    }

    if (
      timePreference === "SPECIFIC_DATE_AND_TIME" &&
      (!state.specific_date_time || !moment(state.specific_date_time).isValid())
    ) {
      isValid = false;
      errorMessage = "Please fill in Specific date and time";
    }

    if (!isValid) {
      showDialog(true, "error", errorMessage);
      setState((prev) => ({ ...prev, isFormValid: true }));
    }

    return isValid;
  };

  const handleCreateTickect = async (ress) => {
    if (!validateFields()) {
      return;
    }

    setState((prev) => ({
      ...prev,
      isRegistering: true,
    }));

    const {
      serviceRequired,
      specificRequirement,
      name,
      phoneNumber,
      alternatePhoneNumber,
      houseNumber,
      locality,
      city,
      picklocation,
      droplocation,
      offerprice,
      state: stateValue,
      country,
      pincode,
      timePreference,
      offerCode,
      center_obj_id,
      selectedVehicle,
    } = state;

    if (serviceRequired !== "64462802f77b1ff1d68890fd") {
      if (
        !(
          serviceRequired &&
          name &&
          phoneNumber &&
          houseNumber &&
          pincode &&
          timePreference &&
          offerCode
        )
      ) {
        setState((prev) => ({
          ...prev,
          isFormValid: true,
        }));

        showDialog(true, "error", "Please fill in all required details");
        return;
      }
    } else {
      if (
        !(
          picklocation &&
          droplocation &&
          phoneNumber &&
          pincode &&
          timePreference &&
          offerCode
        )
      ) {
        setState((prev) => ({
          ...prev,
          isFormValid: true,
        }));

        showDialog(true, "error", "Please fill in all required details");
        return;
      }
    }

    setState((prev) => ({
      ...prev,
      isRegistering: true,
    }));

    if (state.timePreference === "SPECIFIC_DATE_AND_TIME") {
      if (!state.specific_date_time) {
        showDialog(true, "error", "Please fill in Specific date and time");
        return;
      }
    }

    let payload =
      serviceRequired === "64462802f77b1ff1d68890fd"
        ? {
          service_provided_for: serviceRequired,
          vehicleId: selectedVehicle,
          personal_details: {
            primary_phone: {
              country_code: "+91",
              mobile_number: phoneNumber,
            },
            alternate_phone: {
              country_code: "+91",
              mobile_number: alternatePhoneNumber,
            },
            name: name,
          },
          pickupAddress: {
            longitude: "",
            latitude: "",
            house_number: "",
            locality: "",
            city: "",
            state: "",
            short_code_for_place: "",
            pincode: pincode,
            pick_location: picklocation,
          },
          dropAddress: {
            longitude: "",
            latitude: "",
            house_number: "",
            locality: "",
            city: "",
            state: "",
            short_code_for_place: "",
            drop_location: droplocation,
          },
          center_obj_id: center_obj_id,
          offers_applied: {
            offer_code: offerCode,
          },
          time_preference: {
            time_preference_type: timePreference,
            specific_date_time: state.specific_date_time,
          },
          device_id: "",
          urldata: window.location.href,
          customer_offer_price: offerprice,
        }
        : {
          service_provided_for: serviceRequired,
          specific_requirement: specificRequirement,
          personal_details: {
            primary_phone: {
              country_code: "+91",
              mobile_number: phoneNumber,
            },
            alternate_phone: {
              country_code: "+91",
              mobile_number: alternatePhoneNumber,
            },
            name: name,
          },
          time_preference: {
            time_preference_type: timePreference,
            specific_date_time: state.specific_date_time,
          },
          offers_applied: {
            offer_code: offerCode,
          },
          address_details: {
            house_number: houseNumber,
            locality: locality,
            city: city,
            state: stateValue,
            pincode: pincode,
            country: country,
          },
          center_obj_id: center_obj_id,
          urldata: window.location.href,
        };

    if (serviceRequired === "64462802f77b1ff1d68890fd") {
      await new CenterComponentApi()
        .PublicTicketBookingPickDrop(payload)
        .then(async (res) => {
          if (res?.message === "Please complete the payment process") {
            setState((prev) => ({
              ...prev,
              tickectId: res?.data?.ticket_id,
              plateformCharge: res?.data?.plateform_charge,
              consumerId: res?.data?.consumer_id,
            }));
            handleInitiatePayment(
              ress?.consumerDetails?._id,
              ress?.token,
              res?.data?.ticket_id
            );
          } else {
            setState((prev) => ({
              ...prev,
              ticketModalData: res?.data,
              TicketModalOpen: true,
              isRegistering: false,
            }));
            resetForm();
          }
        })
        .catch((err) => {
          setState((prev) => ({
            ...prev,
            isRegistering: false,
          }));
          showDialog(true, "error", err?.response?.data?.message);
        });
    } else {
      await new CenterComponentApi()
        .PublicTicketBooking(payload)
        .then(async (res) => {
          if (res?.message === "Please complete the payment process") {
            setState((prev) => ({
              ...prev,
              tickectId: res?.data?._id,
              consumerId: ress.consumerDetails?._id,
            }));
            handleInitiatePayment(
              ress?.consumerDetails?._id,
              ress?.token,
              res?.data?._id
            );
          } else {
            setState((prev) => ({
              ...prev,
              ticketModalData: res?.data,
              TicketModalOpen: true,
              isRegistering: false,
            }));
            resetForm();
          }
        })
        .catch((err) => {
          console.log(err);
          setState((prev) => ({
            ...prev,
            isRegistering: false,
          }));
          showDialog(true, "error", err?.response?.data?.message);
        });
    }
  };

  const handleSendOtp = async () => {
    if (!state.phoneNumber) {
      showDialog(true, "error", "Mobile number is required");
      return;
    }

    if (state.phoneNumber.length !== 10) {
      showDialog(true, "error", "Please enter a valid 10-digit mobile number");
      return;
    }

    if (!validateFields()) {
      return;
    }

    try {
      const _data = {
        country_code: "+91",
        mobile_number: state.phoneNumber,
      };

      setState((prev) => ({
        ...prev,
        isRegistering: true,
      }));

      await axios({
        method: "post",
        url: `${BASE_URL}consumerAppAppRoute/sent-otp-by-web`,
        data: _data,
      }).then((res) => {
        setState((prev) => ({
          ...prev,
          verifyOtp: true,
          otpSent: true,
          isRegistering: false,
        }));
        showDialog(true, "success", "OTP sent successfully to your mobile");
      });
    } catch (error) {
      console.log(error);
      showDialog(true, "error", "Failed to send OTP. Please try again.");
      setState((prev) => ({
        ...prev,
        isRegistering: false,
      }));
    }
  };

  const handleVerifyOtp = async () => {
    if (!state.otp) {
      showDialog(true, "error", "Please enter the OTP");
      return;
    }

    try {
      const _data = {
        country_code: "+91",
        mobile_number: state.phoneNumber,
        otp: parseInt(state.otp),
      };

      setState((prev) => ({
        ...prev,
        isRegistering: true,
      }));

      await axios({
        method: "post",
        url: `${BASE_URL}consumerAppAppRoute/verify-otp-by-web`,
        data: _data,
      }).then((res) => {
        setState((prev) => ({
          ...prev,
          verifyOtp: false,
          isRegistering: false,
        }));
        handleCheckUserExist();
      });
    } catch (error) {
      setState((prev) => ({
        ...prev,
        isRegistering: false,
      }));
      showDialog(true, "error", "Wrong OTP. Please try again.");
    }
  };

  const handleCheckUserExist = async () => {
    try {
      let res1 = await axios.post(
        `${BASE_URL}consumerAppAppRoute/register-consumer-by-web`,
        {
          personal_details: {
            phone: {
              country_code: "+91",
              mobile_number: state.phoneNumber,
            },
            name: state.name,
          },
          address_details_permanent: {
            pincode: state.pincode,
          },
        }
      );

      if (res1?.data?.status === 200) {
        handleCreateTickect(res1?.data?.data);
      }
    } catch (error) {
      console.log("Error", error);
      setState((prev) => ({
        ...prev,
        isRegistering: false,
      }));
      showDialog(true, "error", "Failed to verify user. Please try again.");
    }
  };

  const handleInitiatePayment = async () => {
    setState((prev) => ({
      ...prev,
      razorpayinitiate: true,
    }));
  };

  const handleClose = () => {
    setState((prev) => ({
      ...prev,
      TicketModalOpen: false,
    }));
  };

  const getPincodeFromLocation = () => {
    if (!navigator.geolocation) {
      showDialog(
        true,
        "error",
        "Geolocation is not supported by your browser."
      );
      return;
    }

    setState((prev) => ({
      ...prev,
      isFetchingPincode: true,
    }));

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const nominatimApiUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;

        fetch(nominatimApiUrl)
          .then((response) => response.json())
          .then((data) => {
            if (data && data.address) {
              const pincode = data.address.postcode || "";
              setState((prev) => ({
                ...prev,
                pincode,
                isFetchingPincode: false,
              }));

              // Now fetch address details based on pincode
              fetchAddressDetailsByPincode(pincode);
            } else {
              setState((prev) => ({
                ...prev,
                isFetchingPincode: false,
              }));
              showDialog(true, "error", "Pincode not found for your location.");
            }
          })
          .catch((error) => {
            console.error("Error fetching location data:", error);
            setState((prev) => ({
              ...prev,
              isFetchingPincode: false,
            }));
            showDialog(true, "error", "Failed to fetch location data.");
          });
      },
      (error) => {
        console.error("Error getting location:", error.message);
        setState((prev) => ({
          ...prev,
          isFetchingPincode: false,
        }));
        showDialog(
          true,
          "error",
          "Unable to retrieve your location. Please check permissions."
        );
      }
    );
  };

  const fetchAddressDetailsByPincode = (pincode) => {
    if (!pincode || pincode.length !== 6) {
      return;
    }

    setState((prev) => ({
      ...prev,
      isFetchingPincode: true,
    }));

    fetch(`https://api.postalpincode.in/pincode/${pincode}`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data[0]?.Status === "Success") {
          const postOffice = data[0]?.PostOffice?.[0];
          if (postOffice) {
            setState((prev) => ({
              ...prev,
              city: postOffice.District || postOffice.Block || "",
              locality: postOffice.Name || "",
              state: postOffice.State || "",
              isFetchingPincode: false,
            }));
          }
        } else {
          setState((prev) => ({
            ...prev,
            isFetchingPincode: false,
          }));
          showDialog(
            true,
            "info",
            "Address details not found for this pincode."
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching address details:", error);
        setState((prev) => ({
          ...prev,
          isFetchingPincode: false,
        }));
        showDialog(true, "error", "Failed to fetch address details.");
      });
  };

  useEffect(() => {
    if (state.pincode && state.pincode.length === 6) {
      fetchAddressDetailsByPincode(state.pincode);
    }
  }, [state.pincode]);

  const {
    toast: snackBarValues,
    isFormValid,
    serviceRequired,
    specificRequirement,
    name,
    phoneNumber,
    alternatePhoneNumber,
    houseNumber,
    locality,
    city,
    picklocation,
    droplocation,
    offerprice,
    pincode,
    state: stateValue,
    country,
    timePreference,
    offerCode,
    otp,
    vehicles,
    selectedVehicle,
    razorpayinitiate,
    plateformCharge,
    tickectId,
    consumerId,
    ticketModalData,
    TicketModalOpen,
    centerName,
    isCenterExist,
    isMobile,
    isRegistering,
    verifyOtp,
    paymentStatus,
    otpSent,
    isFetchingPincode,
    bannerImage,
    isFetchingBanner,
  } = state;

  // Determine which banner to display
  const displayBannerImage =
    bannerImage || (isMobile ? MobileBanner : DesktopBanner);

  const CopyButton = ({ webLink }) => {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = () => {
      navigator.clipboard.writeText(webLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    };

    return (
      <IconButton
        onClick={copyToClipboard}
        color="primary"
        size="small"
        className="flex items-center"
      >
        <FaCopy className="mr-1" />
        <Typography variant="caption" className="ml-1">
          {copied ? "Copied!" : "Copy"}
        </Typography>
      </IconButton>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div className="max-w-8xl mx-auto">
        {razorpayinitiate === true && (
          <RazorPayment
            amount={plateformCharge}
            tickectId={tickectId}
            phonenumber={phoneNumber}
            consumerId={consumerId}
            isPickDrop={serviceRequired === "64462802f77b1ff1d68890fd"}
          />
        )}

        {/* Success Modal */}
        <Dialog
          open={TicketModalOpen}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            className="flex items-center justify-center"
          >
            <VerifiedIcon color="success" fontSize="large" className="mr-2" />
            <Typography variant="h6" className="text-center">
              Request Created Successfully!
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <div className="space-y-4">
                <div className="flex justify-between">
                  <Typography variant="body1" className="font-medium">
                    Ticket ID:
                  </Typography>
                  <Typography variant="body1">
                    {ticketModalData?.ticket_id}
                  </Typography>
                </div>
                <Divider />
                <div className="flex justify-between">
                  <Typography variant="body1" className="font-medium">
                    Status:
                  </Typography>
                  <Typography variant="body1">
                    {ticketModalData?.ticket_status}
                  </Typography>
                </div>
                <Divider />
                <div className="flex justify-between">
                  <Typography variant="body1" className="font-medium">
                    Created At:
                  </Typography>
                  <Typography variant="body1">
                    {moment(ticketModalData?.createdAt).format(
                      "DD MMM YYYY, hh:mm A"
                    )}
                  </Typography>
                </div>
                <Divider />
                <div className="flex justify-between items-center">
                  <Typography variant="body1" className="font-medium">
                    Tracking Link:
                  </Typography>
                  <div className="flex items-center space-x-2">
                    <CopyButton
                      webLink={`https://app.onit.services/#/ServiceStatus/?${ticketModalData?._id}`}
                    />
                    <Link
                      to={`/ServiceStatus/?${ticketModalData?._id}`}
                      className="flex items-center text-blue-600 hover:text-blue-800"
                    >
                      <FaExternalLinkAlt className="mr-1" />
                      <Typography variant="caption">Open</Typography>
                    </Link>
                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="justify-center">
            <Button
              onClick={handleClose}
              variant="contained"
              color="primary"
              autoFocus
              className="w-full"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Toast Notification */}
        <Snackbar
          open={snackBarValues.open}
          autoHideDuration={snackBarValues.duration}
          onClose={() => closeDialog(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={() => closeDialog(false)}
            severity={snackBarValues.type === "error" ? "error" : "success"}
            sx={{ width: "100%" }}
          >
            {snackBarValues.msg}
          </Alert>
        </Snackbar>

        {/* Banner Image */}
        <Card className="shadow-md">
          {isFetchingBanner ? (
            <div className="w-full h-48 md:h-64 flex items-center justify-center bg-gray-200">
              <CircularProgress />
              <Typography variant="body2" className="ml-2">
                Loading banner...
              </Typography>
            </div>
          ) : (
            <CardMedia
              component="img"
              image={displayBannerImage}
              alt="Responsive Banner"
              className="w-full h-auto"
            />
          )}
        </Card>

        {/* Main Form */}
        <Card className="rounded-lg shadow-md p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Service Required */}
            <FormControl fullWidth>
              <InputLabel id="service-required-label">
                Service You Required *
              </InputLabel>
              <Select
                labelId="service-required-label"
                id="serviceRequired"
                name="serviceRequired"
                value={serviceRequired}
                onChange={handleChange}
                label="Service You Required *"
                error={isFormValid && !serviceRequired}
              >
                <MenuItem value="">
                  <em>Select a service</em>
                </MenuItem>
                {state.servicesList?.map((ite) => (
                  <MenuItem key={ite._id} value={ite._id}>
                    {ite.service_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Specific Requirement (for other services) */}
            {serviceRequired !== "64462802f77b1ff1d68890fd" && (
              <FormControl fullWidth>
                <TextField
                  name="specificRequirement"
                  label="Specific Requirement"
                  value={specificRequirement}
                  onChange={handleChange}
                  minRows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter your specific requirement here..."
                />
              </FormControl>
            )}

            {/* Vehicle Selection (for pick/drop service) */}
            {serviceRequired === "64462802f77b1ff1d68890fd" && (
              <>
                <FormControl fullWidth>
                  <InputLabel id="vehicle-type-label">
                    Vehicle Type *
                  </InputLabel>
                  <Select
                    labelId="vehicle-type-label"
                    id="selectedVehicle"
                    name="selectedVehicle"
                    value={selectedVehicle}
                    onChange={handleChange}
                    label="Vehicle Type *"
                    error={isFormValid && !selectedVehicle}
                  >
                    <MenuItem value="">
                      <em>Select a vehicle</em>
                    </MenuItem>
                    {vehicles?.map((ite) => (
                      <MenuItem key={ite._id} value={ite._id}>
                        {ite?.vehicleType}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {selectedVehicle && (
                  <div className="col-span-1 md:col-span-2 flex items-center text-green-600 text-sm">
                    <FaInfoCircle className="mr-2" />
                    <Typography variant="body2">
                      {`Platform fee for ${vehicles.find((e) => e?._id === selectedVehicle)
                          ?.vehicleType
                        } will be Rs. ${vehicles.find((e) => e?._id === selectedVehicle)
                          ?.platformCharge
                        }`}
                    </Typography>
                  </div>
                )}

                <TextField
                  fullWidth
                  label="Pick Location *"
                  name="picklocation"
                  value={picklocation}
                  onChange={handleChange}
                  error={isFormValid && !picklocation}
                  helperText={isFormValid && !picklocation ? "Required" : ""}
                />

                <TextField
                  fullWidth
                  label="Drop Location *"
                  name="droplocation"
                  value={droplocation}
                  onChange={handleChange}
                  error={isFormValid && !droplocation}
                  helperText={isFormValid && !droplocation ? "Required" : ""}
                />

                <TextField
                  fullWidth
                  label="Offer Price *"
                  name="offerprice"
                  type="number"
                  value={offerprice}
                  onChange={handleChange}
                  error={isFormValid && !offerprice}
                  helperText={isFormValid && !offerprice ? "Required" : ""}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                  }}
                />
              </>
            )}

            {/* Contact Information */}
            <TextField
              fullWidth
              label="Name (Contact Person) *"
              name="name"
              value={name}
              onChange={handleChange}
              error={isFormValid && !name}
              helperText={isFormValid && !name ? "Required" : ""}
            />

            <TextField
              fullWidth
              label="Phone Number *"
              name="phoneNumber"
              value={phoneNumber}
              onChange={handleChange}
              error={isFormValid && !phoneNumber}
              helperText={isFormValid && !phoneNumber ? "Required" : ""}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+91</InputAdornment>
                ),
              }}
              inputProps={{
                maxLength: 10,
              }}
            />

            {/* Address Fields (for non-pick/drop services) */}
            {serviceRequired !== "64462802f77b1ff1d68890fd" && (
              <>
                <TextField
                  fullWidth
                  label="Alternate Phone Number"
                  name="alternatePhoneNumber"
                  value={alternatePhoneNumber}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">+91</InputAdornment>
                    ),
                  }}
                  inputProps={{
                    maxLength: 10,
                  }}
                />

                <TextField
                  fullWidth
                  label="House Number / Street *"
                  name="houseNumber"
                  value={houseNumber}
                  onChange={handleChange}
                  error={isFormValid && !houseNumber}
                  helperText={isFormValid && !houseNumber ? "Required" : ""}
                />

                {/* Pincode */}
                <div className="col-span-1">
                  <FormControl fullWidth>
                    <TextField
                      label="Pincode *"
                      name="pincode"
                      value={pincode}
                      onChange={handleChange}
                      error={isFormValid && !pincode}
                      helperText={isFormValid && !pincode ? "Required" : ""}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Button
                              startIcon={<LocationOnIcon />}
                              onClick={getPincodeFromLocation}
                              variant="outlined"
                              size="small"
                              className="whitespace-nowrap"
                              disabled={isFetchingPincode}
                            >
                              {isFetchingPincode ? (
                                <CircularProgress size={20} />
                              ) : (
                                "Fetch"
                              )}
                            </Button>
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        maxLength: 6,
                      }}
                    />
                  </FormControl>
                </div>

                <TextField
                  fullWidth
                  label="Locality *"
                  name="locality"
                  value={locality}
                  onChange={handleChange}
                  error={isFormValid && !locality}
                  helperText={isFormValid && !locality ? "Required" : ""}
                />

                <TextField
                  fullWidth
                  label="City *"
                  name="city"
                  value={city}
                  onChange={handleChange}
                  error={isFormValid && !city}
                  helperText={isFormValid && !city ? "Required" : ""}
                />

                <FormControl fullWidth>
                  <InputLabel id="state-label">State *</InputLabel>
                  <Select
                    labelId="state-label"
                    id="state"
                    name="state"
                    value={stateValue}
                    onChange={handleChange}
                    label="State *"
                    error={isFormValid && !stateValue}
                  >
                    <MenuItem value="">
                      <em>Select state</em>
                    </MenuItem>
                    {IndianStates?.map((state) => (
                      <MenuItem key={state.value} value={state.value}>
                        {state.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  label="Country"
                  name="country"
                  value={country}
                  onChange={handleChange}
                  disabled
                />
              </>
            )}

            {/* Time Preference */}
            <FormControl fullWidth>
              <InputLabel id="time-preference-label">
                Time Preference *
              </InputLabel>
              <Select
                labelId="time-preference-label"
                id="timePreference"
                name="timePreference"
                value={timePreference}
                onChange={handleChange}
                label="Time Preference *"
                error={isFormValid && !timePreference}
              >
                <MenuItem value="">
                  <em>Select time preference</em>
                </MenuItem>
                {serviceRequired !== "64462802f77b1ff1d68890fd"
                  ? AVAILABLE_TIME_PREFERENCES?.map((pref) => (
                    <MenuItem key={pref} value={pref}>
                      {pref.replace(/_/g, " ")}
                    </MenuItem>
                  ))
                  : PICK_DROP_AVAILABLE_TIME_PREFERENCES?.map((pref) => (
                    <MenuItem key={pref} value={pref}>
                      {pref.replace(/_/g, " ")}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            {/* Specific Date and Time */}
            {timePreference === "SPECIFIC_DATE_AND_TIME" && (
              <div className="col-span-1 md:col-span-2">
                <MobileDateTimePicker
                  label="Select Date and Time *"
                  value={state.specific_date_time || null}
                  onChange={onChangeSpecificDateAndTime}
                  minDateTime={moment()}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth helperText="" />
                  )}
                />
              </div>
            )}

            {/* Offer Code */}
            <TextField
              fullWidth
              label="Offer Code"
              name="offerCode"
              value={offerCode}
              onChange={handleChange}
            />

            {/* Partner Name */}
            {isCenterExist && (
              <TextField
                fullWidth
                label="Partner Name"
                value={centerName}
                disabled
                InputProps={{
                  className: "font-medium",
                }}
              />
            )}

            {/* OTP Verification */}
            {verifyOtp ? (
              <>
                <TextField
                  fullWidth
                  label="OTP *"
                  name="otp"
                  value={otp}
                  onChange={handleChange}
                  type="number"
                  InputProps={{
                    className: "bg-blue-50",
                  }}
                />

                <div className="col-span-1 flex items-end">
                  <Button
                    onClick={handleVerifyOtp}
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    disabled={isRegistering}
                    endIcon={
                      isRegistering ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : null
                    }
                  >
                    {isRegistering ? "Verifying..." : "VERIFY OTP"}
                  </Button>
                </div>
              </>
            ) : (
              <div className="col-span-1 md:col-span-2 flex justify-center mt-4">
                <Button
                  onClick={otpSent ? handleCheckUserExist : handleSendOtp}
                  disabled={isRegistering}
                  variant="contained"
                  color="primary"
                  size="large"
                  endIcon={
                    isRegistering ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <SendIcon />
                    )
                  }
                  className="w-full md:w-auto"
                >
                  {isRegistering
                    ? "Processing..."
                    : otpSent
                      ? "SUBMIT REQUEST"
                      : "GENERATE OTP"}
                </Button>
              </div>
            )}
            {paymentStatus && (
              <div className="col-span-1 md:col-span-2 text-center">
                <Typography variant="body2" color="textSecondary">
                  {paymentStatus}
                </Typography>
              </div>
            )}
          </div>
        </Card>
      </div>
    </LocalizationProvider>
  );
};

export default PublicTicketBooking;
